var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 34.25H30C30.7917 34.25 31.5208 33.8281 31.9167 33.132L39.6944 19.632C40.0972 18.9359 40.0972 18.0781 39.7014 17.375C39.3056 16.6719 38.5764 16.25 37.7778 16.25H10C9.20833 16.25 8.47917 16.6719 8.08333 17.368L3.33333 25.6086V7.25C3.33333 6.63125 3.83333 6.125 4.44444 6.125H12.6042C12.8958 6.125 13.1806 6.24453 13.3889 6.45547L15.2292 8.31875C16.6875 9.79531 18.6667 10.625 20.7292 10.625H28.8889C29.5 10.625 30 11.1313 30 11.75V14H33.3333V11.75C33.3333 9.26797 31.3403 7.25 28.8889 7.25H20.7292C19.5486 7.25 18.4167 6.77891 17.5833 5.93516L15.7431 4.06484C14.9097 3.22109 13.7778 2.75 12.5972 2.75H4.44444C1.99306 2.75 0 4.76797 0 7.25V29.75C0 32.232 1.99306 34.25 4.44444 34.25H26.6667Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.58917bea8823b4adfe6736da7293b735.svg";
export { ForwardRef as ReactComponent };